import { render } from "./editsalesreturn.vue?vue&type=template&id=58b9de1f"
import script from "./editsalesreturn.vue?vue&type=script&lang=js"
export * from "./editsalesreturn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__